<i18n src="@/locales/components/views/packing_house/production/uniq_final_packing_list/package_from_stock.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<template>
  <div class="sm:col-span-8 md:flex">
    <div class="flex-auto">
      <label class="label-form">{{ $t("model.package._self") }}</label>
      <div class="mt-1">
        <select-form
          class="flex-auto"
          :options="options"
          :clearable="from_form"
          v-model="id"
          label="full_label"
        />
      </div>
    </div>
    <div class="flex-none pl-1" v-if="render_quantity">
      <label class="label-form">{{ $t("model.package.quantity") }}</label>
      <div class="mt-1">
        <input
          type="number"
          min="1"
          :max="this.max_quantity"
          v-model.number.lazy="quantity"
          @change="quantity = parsedQuantity(quantity)"
          :class="['input-text']"
          autofocus
        />
      </div>
    </div>
    <!-- <div class="flex-none pl-1 pt-6 text-right" v-if="from_form">
      <button
        class="mt-1"
        @click.prevent="$emit('changeToNewPackage')"
        :title="$t('labels.add_package_link')"
      >
        <i class="fa-solid fa-plus fa-lg px-1"></i>
      </button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "PackageFromStock",
  props: {
    default: {
      type: Object,
      default: null,
    },
    modelValue: {},
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      id: this.modelValue,
      quantity: null,
      render_quantity: false,
    };
  },
  computed: {
    current_option: function () {
      if (this.id) return this.options.find((option) => option.id == this.id);
      return null;
    },
    from_form: function () {
      // que solo ha sido creado en el formulario pero todavia no en rails.
      if (this.default) return this.default.from_form || false;
      return true;
    },
    max_quantity: function () {
      if (this.current_option) return Math.floor(this.current_option.quantity);
      return 1;
    },
  },
  watch: {
    id: function (id) {
      this.$emit("update:modelValue", id);
    },
    current_option: function (option) {
      if (option) {
        const quantity = this.parsedQuantity(option.quantity);
        this.quantity = quantity;
        return (this.render_quantity = true);
      }
      this.render_quantity = false;
    },
    quantity: function (quantity) {
      this.$emit("update:quantity", quantity);
    },
  },
  methods: {
    setDefaultOption: function () {
      this.id = this.default.id;
      this.quantity = this.default.quantity;
      this.render_quantity = true;
    },
    parsedQuantity: function (value) {
      let parsed_value = Math.floor(value);
      const max = this.max_quantity;

      if (parsed_value > max) return max;
      else if (parsed_value < 1) return 1;
      else return parsed_value;
    },
  },
  mounted: function () {
    if (this.default) this.setDefaultOption();
  },
};
</script>

<style></style>
